<ng-container *ngIf="birth">
    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
           label: 'Birth ID',
           value: birth.BirthID }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Mating ID',
            value: birth.Mating?.MatingID }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Birth Status',
            value: birth.cv_BirthStatus?.BirthStatus }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Line' | translate,
            value: birth.Mating?.Line?.LineName }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Birth Date',
            value: birth.DateBorn | formatShortDate }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Wean Date',
            value: birth.DateWean | formatShortDate }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Housing ID',
            value: birth.Mating?.MaterialPool?.MaterialPoolID }"></ng-template>

    <ng-template [ngTemplateOutlet]="labelValuePair"
        [ngTemplateOutletContext]="{
            label: 'Location',
            value: birth.Mating?.location }"></ng-template>

</ng-container>

<ng-template #labelValuePair let-label="label" let-value="value">
    <div class="form-group row" *ngIf="!useTableFormat">
        <label class="col-md-2 col-form-label">{{label}}</label>
        <div class="col-md-10">
            <p class="form-control-plaintext">
                {{value}}
            </p>
        </div>
    </div>

    <tr *ngIf="useTableFormat">
        <td>{{label}}</td>
        <td>{{value}}</td>
    </tr>
</ng-template>
